import $ from 'jquery';
import { getProductLinks, handleProductLinksPageUpdate } from 'src/pdp/productNavigation/productLinks';
import { clearSessionStorageProductNavigation, clearSessionStorageBackToPLP } from 'src/utils/utils';
import { getItem } from 'ts/helpers/webStorage';
import { SSKeys } from 'ts/pages/lister/productNavigationHelper';
import isEmpty from 'utils/core/isEmpty';

const navIndexResolver = {
  next: (index) => index + 1,
  previous: (index) => index - 1
};

let PRODUCT_LINKS;
let currentPageIndex;
let pagesNumber;
let currentProductIndex;
let referrerProductIndex;
let categoryName;

class PDPProductNavigator {
  static init() {
    getProductLinks()
      .then((response) => {
        currentPageIndex = response.currentPage;
        pagesNumber = response.totalPages;
        PRODUCT_LINKS = response.productLinks;
        categoryName = response.categoryName;

        PDPProductNavigator.setCurrentProductIndex();
        if (PDPProductNavigator.productNavigationIsDisabled()) {
          clearSessionStorageProductNavigation();
          PRODUCT_LINKS = [];
        }
        if (PRODUCT_LINKS.length > 1) {
          $('.next-prev-component__prev-next-wrapper').removeClass('invisible');
        }
        PDPProductNavigator.bindClickEvents();
        PDPProductNavigator.initBackToResultsLink();
      })
      .catch(() => {
        if (!PDPProductNavigator.isLastViewedProductEqualToCurrentProduct()) {
          clearSessionStorageBackToPLP();
        }
        PDPProductNavigator.initBackToResultsLink();
      });
  }

  static bindClickEvents() {
    $('.next-prev-component__prev-next-wrapper').on('click', '.js-pdp-nav', (e) => {
      e.preventDefault();
      const navDirection = $(e.currentTarget).data('pdp-nav-direction');
      PDPProductNavigator.navigate(navDirection);
    });
  }

  static navigate(direction) {
    const navIndex = navIndexResolver[direction].call(null, currentProductIndex);

    if (PRODUCT_LINKS[navIndex]) {
      const navToProductUrl = PRODUCT_LINKS[navIndex].url;
      window.location.replace(navToProductUrl);
    } else {
      PDPProductNavigator.navigateToNextPDP(direction);
    }
  }

  static navigateToNextPDP(direction) {
    const newPageIndex = navIndexResolver[direction].call(null, currentPageIndex);
    handleProductLinksPageUpdate(newPageIndex);

    getProductLinks().then((response) => {
      PRODUCT_LINKS = response.productLinks;
      currentPageIndex = response.currentPage;
      const newProductIndex = direction === 'next' ? 0 : PRODUCT_LINKS.length - 1;

      window.location.replace(PRODUCT_LINKS[newProductIndex].url);
    });
  }

  static setCurrentProductIndex() {
    const id = this.getCurrentProductId();
    const currentProductLink = PRODUCT_LINKS.find((element) => element.id === id);
    currentProductIndex = PRODUCT_LINKS.indexOf(currentProductLink);

    if (currentProductIndex === 0 && currentPageIndex === 1) {
      PDPProductNavigator.disableProductLinksCTA('.next-prev-component__previous');
    } else if (currentProductIndex >= PRODUCT_LINKS.length - 1 && currentPageIndex === pagesNumber) {
      PDPProductNavigator.disableProductLinksCTA('.next-prev-component__next');
    }
  }

  static disableProductLinksCTA(CTA) {
    $(`.next-prev-component__prev-next-wrapper ${CTA}`).addClass('disabled');
  }

  static getCurrentProductId() {
    const pathName = window.location.pathname.substr(1);
    return pathName.substr(0, pathName.indexOf('/'));
  }

  static getReferrerProductURL() {
    return document.referrer.substring(window.location.origin.length);
  }

  static isURLIncludedInProductLinks(string) {
    return PRODUCT_LINKS.find((element) => element.url === string);
  }

  static isReferrerPrevToCurrentProduct() {
    return referrerProductIndex + 1 === currentProductIndex;
  }

  static isReferrerNextToCurrentProduct() {
    return referrerProductIndex - 1 === currentProductIndex;
  }

  static isLastViewedProductEqualToCurrentProduct() {
    const lastViewedProduct = getItem(SSKeys.LastViewedProduct);
    const currentProduct = getItem(SSKeys.CurrentProduct);

    return lastViewedProduct ? lastViewedProduct === currentProduct : true;
  }

  static currentProductIsIncluded() {
    return currentProductIndex >= 0;
  }

  static productNavigationIsDisabled() {
    const referrerProductLink = PDPProductNavigator.isURLIncludedInProductLinks(
      PDPProductNavigator.getReferrerProductURL()
    );
    let isReferrerNearToCurrentProduct;
    if (referrerProductLink) {
      referrerProductIndex = PRODUCT_LINKS.indexOf(referrerProductLink);
      isReferrerNearToCurrentProduct =
        PDPProductNavigator.isReferrerPrevToCurrentProduct() && PDPProductNavigator.isReferrerNextToCurrentProduct();
    }

    return !isReferrerNearToCurrentProduct && !PDPProductNavigator.currentProductIsIncluded();
  }

  static initBackToResultsLink() {
    const $backToResultsLink = $('.next-prev-component__back');
    const backToResultsLinkValue = getItem(SSKeys.BackToResults);

    if (!isEmpty(backToResultsLinkValue)) {
      $backToResultsLink
        .children('a')
        .first()
        .attr('href', backToResultsLinkValue)
        .attr('rel', categoryName ? 'follow' : 'nofollow');
      $backToResultsLink.find('.js-to-category-name').html(` to ${categoryName || 'results'}`);
      $backToResultsLink.removeClass('invisible');
    }
  }
}

function pdpProductNavigation() {
  PDPProductNavigator.init();
}

export default pdpProductNavigation;
